import React, { useRef } from 'react';
import { Button } from '../../core/button';
import FontAwesomeIcon from '../../core/fa_icon';
import Notification from '../../core/notification';

type Props = {
  onDelete: () => void;
}

/**
 * Button for deleteing a bundle row by double-clicking.
 */
export const BundleRowDelete: React.FC<Props> = ({ onDelete }) => {
  const clickedAt = useRef<number>(0);
  const notiyTimeoutHandler = useRef<NodeJS.Timeout>(null);

  const threshold = 250;

  return (
    <Button
      onClick={e => {
        e.stopPropagation();
        
        const delta = Date.now() - clickedAt.current;
        clearTimeout(notiyTimeoutHandler.current);

        if (delta < threshold) {
          onDelete();
        } else {
          notiyTimeoutHandler.current = setTimeout(() =>
            Notification.show("Dubbeltryck på knappen för att ta bort raden"), threshold);
        }

        clickedAt.current = Date.now();
      }}>
      <FontAwesomeIcon name="trash" />
    </Button>
  )
}